import { render, staticRenderFns } from "./QuestionCriteriaOrderComponent.vue?vue&type=template&id=dcab566a"
import script from "./QuestionCriteriaOrderComponent.vue?vue&type=script&lang=js"
export * from "./QuestionCriteriaOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports